import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductTransferOwnershipDocument.Save.IRequest;
type Response = Api.Core.ProductTransferOwnershipDocument.Save.IResponse;
type Headers = Api.Core.ProductTransferOwnershipDocument.Save.IHeaders;
const url = '/api/ProductManagement/ProductTransferOwnershipDocument/:productId';
export default async function productTransferOwnershipDocumentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { productId: body?.productId, documentId: body?.id }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
